import { IWPImage, IWPLink } from "@/src/types";
import React from "react";

import S from "./TextSlideshow.styled";
import { getImage } from "gatsby-plugin-image";

import { Link } from "gatsby";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export interface Props {
  slides: {
    title: string;
    text: string;
    link: IWPLink;
  }[];
  backgroundImage: IWPImage;
}

const TextSlideshow: React.FC<Props> = ({ slides, backgroundImage }) => {
  const backgroundImageData = backgroundImage?.localFile?.childImageSharp
    ?.gatsbyImageData
    ? getImage(backgroundImage.localFile.childImageSharp.gatsbyImageData)
    : null;

  return (
    <section className="bg-cover w-full flex items-center justify-center py-12 relative overflow-hidden">
      <div className="absolute inset-0 bg-gray-700 opacity-60 z-10"></div>
      {backgroundImageData && (
        <S.BackgroundImage
          image={backgroundImageData}
          alt={"Bakgrundsbild för slideshow"}
          className={"object-center object-cover pointer-events-none"}
        />
      )}
      <div
        className={
          "mx-auto max-w-7xl flex items-center text-center text-white z-20"
        }
        style={{ width: "80%" }}
      >
        <Swiper
          loop={true}
          navigation={true}
          autoplay={{ delay: 4000 }}
          pagination={{ clickable: true }}
          modules={[Navigation, Autoplay, Pagination]}
          className="mySwiper"
        >
          {slides.map((slide, idx) => (
            <SwiperSlide
              className="flex flex-col items-baseline text-center justify-center"
              key={idx}
            >
              <div className="relative md:mx-auto max-w-7xl md:py-24 relative flex items-center text-center md:text-left">
                <div className="flex flex-col items-baseline md:items-baseline items-center md:pr-12 md:px-0 px-6">
                  <S.slidesWrap
                    className={
                      "flex flex-col items-baseline p-6 md:p-12 justify-center text-center keen-slider__slide number-slide1" +
                      idx
                    }
                  >
                    <h3 className="text-center w-full md:text-left">
                      {slide.title}
                    </h3>
                    <div dangerouslySetInnerHTML={{ __html: slide.text }} />
                    <S.slideButton className="mt-6 mr-2 flex items-center self-center lg:self-auto justify-center text-base font-medium rounded-full text-white bg-metlab-500 transition duration-200 ease-in-out hover:bg-green-600 py-4 px-6 md:">
                      <Link to={slide.link.url}>{slide.link.title}</Link>
                    </S.slideButton>
                  </S.slidesWrap>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default TextSlideshow;
